// Dates, prices, phone rules and the calendar file. Times are club-local (Asia/Jakarta, UTC+7, no DST).
const WD = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
const MO = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

export const pad = (n: number) => String(n).padStart(2, "0");
export const iso = (d: Date) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
export const fromIso = (s: string) => {
  const [y, m, d] = s.split("-").map(Number);
  return new Date(y, m - 1, d);
};
export function next14(): string[] {
  const t = new Date();
  const base = new Date(t.getFullYear(), t.getMonth(), t.getDate());
  return Array.from({ length: 14 }, (_, i) => iso(new Date(base.getFullYear(), base.getMonth(), base.getDate() + i)));
}
export const weekday = (s: string) => WD[fromIso(s).getDay()];
export const dayNum = (s: string) => fromIso(s).getDate();
/** "Thu 16 Oct" */
export const dateLabel = (s: string) => {
  const d = fromIso(s);
  return `${WD[d.getDay()]} ${d.getDate()} ${MO[d.getMonth()]}`;
};
/** "Rp 450.000" */
export const rp = (n: number) => "Rp " + Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
export const endTime = (time: string, duration: number) => {
  const m = Number(time.slice(0, 2)) * 60 + Number(time.slice(3, 5)) + duration;
  return `${pad(Math.floor(m / 60) % 24)}:${pad(m % 60)}`;
};
export const isPast = (date: string, time: string) => {
  const [y, mo, d] = date.split("-").map(Number);
  const start = new Date(y, mo - 1, d, Number(time.slice(0, 2)), Number(time.slice(3, 5)));
  return start.getTime() <= Date.now();
};

/** Strip spaces, dashes, dots and brackets so "0812-3456 7890" reads as one number. */
export const cleanPhone = (v: string) => v.replace(/[\s\-.()]/g, "");
export const phoneOk = (v: string) => /^(\+62|0)8\d{7,12}$/.test(cleanPhone(v));
export const emailOk = (v: string) => /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v.trim());

export const ADDRESS = "Jl. Arteri Permata Hijau No.98, Grogol Utara, Kebayoran Lama, Jakarta Selatan 12210";
export const MAPS = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent("The Dome, " + ADDRESS)}`;

/** Build an .ics for the booking and download it. Club time is UTC+7, written as UTC. */
export function downloadIcs(b: { ref: string; date: string; time: string; duration: number; court: number }) {
  const [y, mo, d] = b.date.split("-").map(Number);
  const startUtc = Date.UTC(y, mo - 1, d, Number(b.time.slice(0, 2)) - 7, Number(b.time.slice(3, 5)));
  const endUtc = startUtc + b.duration * 60000;
  const stamp = (ms: number) => new Date(ms).toISOString().replace(/[-:]/g, "").replace(/\.\d{3}/, "");
  const esc = (s: string) => s.replace(/[\\;,]/g, (c) => "\\" + c);
  const ics = [
    "BEGIN:VCALENDAR",
    "VERSION:2.0",
    "PRODID:-//The Dome//Booking//EN",
    "CALSCALE:GREGORIAN",
    "METHOD:PUBLISH",
    "BEGIN:VEVENT",
    `UID:${b.ref}@thedome.id`,
    `DTSTAMP:${stamp(Date.now())}`,
    `DTSTART:${stamp(startUtc)}`,
    `DTEND:${stamp(endUtc)}`,
    `SUMMARY:${esc(`Padel at The Dome, Court ${b.court}`)}`,
    `LOCATION:${esc(ADDRESS)}`,
    `DESCRIPTION:${esc(`Booking ${b.ref}. ${b.duration} minutes on Court ${b.court}.`)}`,
    "END:VEVENT",
    "END:VCALENDAR",
    "",
  ].join("\r\n");
  const url = URL.createObjectURL(new Blob([ics], { type: "text/calendar;charset=utf-8" }));
  const a = document.createElement("a");
  a.href = url;
  a.download = `the-dome-${b.ref}.ics`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

export const store = {
  get(k: string): string | null {
    try {
      return localStorage.getItem(k);
    } catch {
      return null;
    }
  },
  set(k: string, v: string) {
    try {
      localStorage.setItem(k, v);
    } catch {
      /* private mode or storage full: remembering is optional */
    }
  },
};

export const esc = (s: string) =>
  s.replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[c]!);
